var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 1.58333V17.4167H2.625C1.89902 17.4167 1.3125 16.7091 1.3125 15.8333V3.16667C1.3125 2.29089 1.89902 1.58333 2.625 1.58333H9.1875ZM9.84375 0H2.625C1.17715 0 0 1.42005 0 3.16667V15.8333C0 17.5799 1.17715 19 2.625 19H18.375C19.8229 19 21 17.5799 21 15.8333V3.16667C21 1.42005 19.8229 0 18.375 0H9.84375ZM10.5 1.58333H18.375C19.101 1.58333 19.6875 2.29089 19.6875 3.16667V15.8333C19.6875 16.7091 19.101 17.4167 18.375 17.4167H10.5V1.58333ZM3.28125 4.75C3.28125 5.18542 3.57656 5.54167 3.9375 5.54167H6.5625C6.92344 5.54167 7.21875 5.18542 7.21875 4.75C7.21875 4.31458 6.92344 3.95833 6.5625 3.95833H3.9375C3.57656 3.95833 3.28125 4.31458 3.28125 4.75ZM3.28125 7.91667C3.28125 8.35208 3.57656 8.70833 3.9375 8.70833H6.5625C6.92344 8.70833 7.21875 8.35208 7.21875 7.91667C7.21875 7.48125 6.92344 7.125 6.5625 7.125H3.9375C3.57656 7.125 3.28125 7.48125 3.28125 7.91667ZM3.28125 11.0833C3.28125 11.5188 3.57656 11.875 3.9375 11.875H6.5625C6.92344 11.875 7.21875 11.5188 7.21875 11.0833C7.21875 10.6479 6.92344 10.2917 6.5625 10.2917H3.9375C3.57656 10.2917 3.28125 10.6479 3.28125 11.0833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelIcon);
export default __webpack_public_path__ + "static/media/panel-icon.3c3c8856e5377ce5311d3a26bf6b6b20.svg";
export { ForwardRef as ReactComponent };